// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useLoader } from "../../../../context/LoaderProvider.jsx";

// const FoodSuperadminAdvertisement = () => {
//     const [advertisements, setAdvertisements] = useState([]);
//     const [formData, setFormData] = useState({
//         title: "",
//         description: "",
//         resolution: "HORIZONTAL",
//         startDate: "",
//         endDate: "",
//         mediaFile: null,
//         amount: "",
//         vendorId: "",
//         type: "IMAGE",
//         adminId: 1
//     });
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [showPaymentModal, setShowPaymentModal] = useState(false);
//     const [selectedAd, setSelectedAd] = useState(null);
//     const [paymentAmount, setPaymentAmount] = useState("");
//     const { showLoader, hideLoader } = useLoader();
//     const [loading, setLoading] = useState(true);
//     const isMobile = window.innerWidth <= 768;

//     const tdStyle = {
//         border: "1px solid #ccc",
//         padding: "10px",
//         textAlign: "left",
//     };

//     // Fetch valid advertisements
//     useEffect(() => {
//         const fetchAdvertisements = async () => {
//             try {
//                 const token = localStorage.getItem("authToken");
//                 showLoader();
//                 setLoading(true);

//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/advertisements/valid`,
//                     {
//                         headers: { Authorization: `Bearer ${token}` }
//                     }
//                 );

//                 const adsArray = Array.isArray(response.data) ? response.data : [response.data];
//                 setAdvertisements(adsArray);

//             } catch (error) {
//                 console.error("❌ Error fetching advertisements:", error);
//                 alert("Failed to fetch advertisements");
//             } finally {
//                 setLoading(false);
//                 hideLoader();
//             }
//         };

//         fetchAdvertisements();
//     }, []);

//     // Handle form input changes
//     const handleChange = (e) => {
//         setFormData({ ...formData, [e.target.name]: e.target.value });
//     };

//     // Handle file selection and set type
//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         let type = "TEXT";
//         if (file.type.startsWith("image/")) {
//             type = "IMAGE";
//         } else if (file.type.startsWith("video/")) {
//             type = "VIDEO";
//         }

//         setFormData(prev => ({ 
//             ...prev, 
//             mediaFile: file,
//             type: type
//         }));
//     };

//     // Add static advertisement
//     const handleAddAdvertisement = async (e) => {
//         e.preventDefault();

//         try {
//             const token = localStorage.getItem("authToken");
//             const adminId = localStorage.getItem("adminId") || 1;
//             showLoader();

//             if (!token) {
//                 alert("Session expired. Please login again.");
//                 return;
//             }

//             const advertisementData = {
//                 advertisementId: 0,
//                 title: formData.title || "Advertisement",
//                 type: formData.type || "IMAGE",
//                 description: formData.description || "",
//                 resolution: formData.resolution || "HORIZONTAL",
//                 startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
//                 endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
//                 amount: formData.amount ? parseFloat(formData.amount) : 0,
//                 vendorId: formData.vendorId ? parseInt(formData.vendorId) : 0,
//                 paymentStatus: "PAID",
//                 transactionId: "SUPERADMIN_STATIC",
//                 orderId: "SUPERADMIN_STATIC",
//                 adminId: parseInt(adminId),
//                 mediaUrl: ""
//             };

//             const fd = new FormData();
//             fd.append(
//                 "advertisementData",
//                 new Blob([JSON.stringify(advertisementData)], { type: "application/json" })
//             );

//             if (formData.mediaFile) {
//                 fd.append("mediaFile", formData.mediaFile, formData.mediaFile.name);
//             }

//             console.log("Submitting advertisement:", advertisementData);

//             const response = await axios.post(
//                 `https://backend.maamaas.com/food/api/advertisements/add-static-payment/1`,
//                 fd,
//                 {
//                     headers: {
//                         "Content-Type": "multipart/form-data",
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             setAdvertisements(prev => [response.data, ...prev]);
//             alert("Advertisement added successfully!");

//             setFormData({
//                 title: "",
//                 description: "",
//                 resolution: "HORIZONTAL",
//                 startDate: "",
//                 endDate: "",
//                 mediaFile: null,
//                 amount: "",
//                 vendorId: "",
//                 type: "IMAGE",
//                 adminId: 1
//             });
//             setShowAddModal(false);

//         } catch (error) {
//             console.error("❌ Error adding advertisement:", error.response?.data || error.message);
//             alert(`Failed to add advertisement: ${error.response?.data?.message || error.message}`);
//         } finally {
//             hideLoader();
//         }
//     };

//     // Handle payment (mark as paid)
//     const handleAddPayment = async () => {
//         if (!selectedAd || !paymentAmount) {
//             alert("Please enter amount");
//             return;
//         }

//         try {
//             const token = localStorage.getItem("authToken");
//             const adminId = localStorage.getItem("adminId") || 1;
//             showLoader();

//             const paymentData = {
//                 advertisementId: selectedAd.advertisementId,
//                 title: selectedAd.title || "Advertisement",
//                 type: selectedAd.type || "IMAGE",
//                 description: selectedAd.description || "",
//                 resolution: selectedAd.resolution || "HORIZONTAL",
//                 startDate: selectedAd.startDate ? new Date(selectedAd.startDate).toISOString() : null,
//                 endDate: selectedAd.endDate ? new Date(selectedAd.endDate).toISOString() : null,
//                 amount: parseFloat(paymentAmount),
//                 vendorId: selectedAd.vendorId || 0,
//                 paymentStatus: "PAID",
//                 transactionId: `SUPERADMIN_${Date.now()}`,
//                 orderId: `ORDER_${Date.now()}`,
//                 adminId: parseInt(adminId),
//                 mediaUrl: selectedAd.mediaUrl || ""
//             };

//             const fd = new FormData();
//             fd.append(
//                 "advertisementData",
//                 new Blob([JSON.stringify(paymentData)], { type: "application/json" })
//             );

//             const response = await axios.post(
//                 `https://backend.maamaas.com/food/api/admin/advertisements/add-static-payment/1`,
//                 fd,
//                 {
//                     headers: {
//                         "Content-Type": "multipart/form-data",
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             setAdvertisements(prev => 
//                 prev.map(ad => 
//                     ad.advertisementId === selectedAd.advertisementId 
//                         ? response.data
//                         : ad
//                 )
//             );

//             alert("Payment added successfully!");
//             setShowPaymentModal(false);
//             setSelectedAd(null);
//             setPaymentAmount("");

//         } catch (error) {
//             console.error("❌ Error adding payment:", error.response?.data || error.message);
//             alert(`Failed to add payment: ${error.response?.data?.message || error.message}`);
//         } finally {
//             hideLoader();
//         }
//     };

//     // Delete advertisement
//     const handleDelete = async (advertisementId) => {
//         if (!window.confirm("Are you sure you want to delete this advertisement?")) {
//             return;
//         }

//         try {
//             const token = localStorage.getItem("authToken");
//             showLoader();

//             await axios.delete(
//                 `https://backend.maamaas.com/food/api/advertisements/delete/${advertisementId}`,
//                 {
//                     headers: { Authorization: `Bearer ${token}` }
//                 }
//             );

//             setAdvertisements(prev => prev.filter(ad => ad.advertisementId !== advertisementId));
//             alert("Advertisement deleted successfully!");

//         } catch (error) {
//             console.error("❌ Error deleting advertisement:", error.response?.data || error.message);
//             alert(`Failed to delete advertisement: ${error.response?.data?.message || error.message}`);
//         } finally {
//             hideLoader();
//         }
//     };

//     // Open payment modal
//     const openPaymentModal = (advertisement) => {
//         setSelectedAd(advertisement);
//         setPaymentAmount(advertisement.amount || "");
//         setShowPaymentModal(true);
//     };

//     // Format date for display
//     const formatDate = (dateString) => {
//         if (!dateString) return "-";
//         const date = new Date(dateString);
//         return date.toLocaleDateString("en-GB", {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric'
//         });
//     };

//     // Modal styles
//     const modalOverlayStyle = {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: 'rgba(0, 0, 0, 0.5)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         zIndex: 9999,
//         padding: isMobile ? '10px' : '20px',
//         overflow: 'auto',
//     };

//     const modalContentStyle = {
//         backgroundColor: '#fff',
//         borderRadius: '8px',
//         width: '100%',
//         maxWidth: isMobile ? '95%' : '500px',
//         maxHeight: '90vh',
//         overflowY: 'auto',
//         boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
//         animation: 'fadeIn 0.3s ease-out',
//     };

//     const modalHeaderStyle = {
//         padding: isMobile ? '15px' : '20px',
//         borderBottom: '1px solid #eee',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         position: 'sticky',
//         top: 0,
//         backgroundColor: '#fff',
//         zIndex: 1,
//     };

//     const modalBodyStyle = {
//         padding: isMobile ? '15px' : '20px',
//     };

//     // Add CSS animation
//     useEffect(() => {
//         const style = document.createElement('style');
//         style.textContent = `
//             @keyframes fadeIn {
//                 from {
//                     opacity: 0;
//                     transform: translateY(-20px);
//                 }
//                 to {
//                     opacity: 1;
//                     transform: translateY(0);
//                 }
//             }

//             @keyframes fadeOut {
//                 from {
//                     opacity: 1;
//                     transform: translateY(0);
//                 }
//                 to {
//                     opacity: 0;
//                     transform: translateY(-20px);
//                 }
//             }

//             .modal-enter {
//                 animation: fadeIn 0.3s ease-out;
//             }

//             .modal-exit {
//                 animation: fadeOut 0.3s ease-out;
//             }
//         `;
//         document.head.appendChild(style);

//         return () => {
//             document.head.removeChild(style);
//         };
//     }, []);

//     return (
//         <div
//             style={{
//                 maxWidth: '1200px',
//                 width: '100%',
//                 margin: '0 auto',
//                 padding: isMobile ? '15px' : '20px',
//                 position: 'relative',
//             }}
//         >
//             {/* Header Section */}
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 marginBottom: '20px',
//                 flexWrap: 'wrap',
//                 gap: '10px'
//             }}>

//                 <button
//                     style={{
//                         padding: isMobile ? '8px 14px' : '10px 16px',
//                         backgroundColor: '#1976d2',
//                         color: '#fff',
//                         border: 'none',
//                         borderRadius: '6px',
//                         cursor: 'pointer',
//                         fontWeight: 'bold',
//                         fontSize: isMobile ? '13px' : '14px',
//                         transition: 'background-color 0.3s',
//                         '&:hover': {
//                             backgroundColor: '#1565c0'
//                         }
//                     }}
//                     onClick={() => setShowAddModal(true)}
//                 >
//                     + Add Advertisement
//                 </button>
//             </div>

//             {/* Table Section */}
//             <div style={{
//                 overflowX: 'auto',
//                 overflowY: 'auto',
//                 width: '100%',
//                 maxHeight: '60vh',
//                 backgroundColor: 'white',
//                 borderRadius: '8px',
//                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                 border: '1px solid #e0e0e0',
//             }}
//             >
//                 <table
//                     style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                         minWidth: '1000px',
//                     }}
//                 >
//                     <thead>
//                         <tr>
//                             {[
//                                 "S.No",
//                                 "Title",
//                                 "Description",
//                                 "Type",
//                                 "Resolution",
//                                 "Media",
//                                 "Start Date",
//                                 "End Date",
//                                 "Amount",
//                                 "Vendor ID",
//                                 "Admin ID",
//                                 "Status",
//                                 "Actions",
//                             ].map((head, i) => (
//                                 <th
//                                     key={i}
//                                     style={{
//                                         border: "1px solid #e0e0e0",
//                                         padding: isMobile ? "8px" : "12px",
//                                         backgroundColor: "#b15cd6",
//                                         fontSize: isMobile ? "12px" : "14px",
//                                         textAlign: "center",
//                                         whiteSpace: "nowrap",
//                                         color: "white",
//                                         fontWeight: "600",
//                                         position: "sticky",
//                                         top: 0,
//                                         zIndex: 10,
//                                     }}
//                                 >
//                                     {head}
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {loading ? (
//                             <tr>
//                                 <td colSpan="13" style={{ textAlign: "center", padding: "40px" }}>
//                                     <div style={{ 
//                                         display: 'flex', 
//                                         justifyContent: 'center', 
//                                         alignItems: 'center',
//                                         flexDirection: 'column',
//                                         gap: '10px'
//                                     }}>
//                                         <div style={{
//                                             width: '40px',
//                                             height: '40px',
//                                             border: '3px solid #f3f3f3',
//                                             borderTop: '3px solid #b15cd6',
//                                             borderRadius: '50%',
//                                             animation: 'spin 1s linear infinite'
//                                         }}></div>
//                                         <span style={{ color: '#666' }}>Loading advertisements...</span>
//                                     </div>
//                                 </td>
//                             </tr>
//                         ) : advertisements.length === 0 ? (
//                             <tr>
//                                 <td colSpan="13" style={{ textAlign: "center", padding: "40px" }}>
//                                     <div style={{ 
//                                         display: 'flex', 
//                                         flexDirection: 'column', 
//                                         alignItems: 'center', 
//                                         gap: '15px',
//                                         color: '#666'
//                                     }}>
//                                         <span>No advertisements found.</span>
//                                         <button
//                                             onClick={() => setShowAddModal(true)}
//                                             style={{
//                                                 padding: '8px 16px',
//                                                 backgroundColor: '#1976d2',
//                                                 color: 'white',
//                                                 border: 'none',
//                                                 borderRadius: '4px',
//                                                 cursor: 'pointer',
//                                                 fontWeight: '500'
//                                             }}
//                                         >
//                                             Create Your First Advertisement
//                                         </button>
//                                     </div>
//                                 </td>
//                             </tr>
//                         ) : (
//                             advertisements.map((ad, index) => (
//                                 <tr key={ad.advertisementId} style={{ 
//                                     backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
//                                     transition: 'background-color 0.2s',
//                                     '&:hover': {
//                                         backgroundColor: '#f0f0f0'
//                                     }
//                                 }}>
//                                     <td style={tdStyle}>{index + 1}</td>
//                                     <td style={tdStyle}>{ad.title || "-"}</td>
//                                     <td style={tdStyle}>{ad.description || "-"}</td>
//                                     <td style={tdStyle}>
//                                         <span style={{
//                                             padding: "4px 8px",
//                                             borderRadius: "4px",
//                                             backgroundColor: ad.type === "IMAGE" ? "#4CAF50" : 
//                                                            ad.type === "VIDEO" ? "#2196F3" : "#9E9E9E",
//                                             color: "white",
//                                             fontSize: "12px",
//                                             fontWeight: "500",
//                                             display: 'inline-block'
//                                         }}>
//                                             {ad.type || "TEXT"}
//                                         </span>
//                                     </td>
//                                     <td style={tdStyle}>
//                                         {ad.resolution === "HORIZONTAL" ? "Horizontal" : 
//                                          ad.resolution === "VERTICAL" ? "Vertical" : "-"}
//                                     </td>
//                                     <td style={tdStyle}>
//                                         {ad.mediaUrl ? (
//                                             ad.type === "IMAGE" ? (
//                                                 <img
//                                                     src={ad.mediaUrl}
//                                                     alt="Advertisement"
//                                                     style={{ 
//                                                         width: "60px", 
//                                                         height: "60px", 
//                                                         objectFit: "cover", 
//                                                         borderRadius: "4px", 
//                                                         border: "1px solid #ccc",
//                                                         cursor: 'pointer'
//                                                     }}
//                                                     onClick={() => window.open(ad.mediaUrl, '_blank')}
//                                                 />
//                                             ) : ad.type === "VIDEO" ? (
//                                                 <div style={{ position: 'relative' }}>
//                                                     <div 
//                                                         style={{
//                                                             width: "60px",
//                                                             height: "60px",
//                                                             backgroundColor: '#2196F3',
//                                                             borderRadius: "4px",
//                                                             display: 'flex',
//                                                             alignItems: 'center',
//                                                             justifyContent: 'center',
//                                                             color: 'white',
//                                                             cursor: 'pointer'
//                                                         }}
//                                                         onClick={() => window.open(ad.mediaUrl, '_blank')}
//                                                     >
//                                                         ▶
//                                                     </div>
//                                                 </div>
//                                             ) : "Text Only"
//                                         ) : "No Media"}
//                                     </td>
//                                     <td style={tdStyle}>{formatDate(ad.startDate)}</td>
//                                     <td style={tdStyle}>{formatDate(ad.endDate)}</td>
//                                     <td style={{ ...tdStyle, fontWeight: 'bold', color: '#1976d2' }}>
//                                         ₹{ad.amount || "0"}
//                                     </td>
//                                     <td style={tdStyle}>{ad.vendorId || "0"}</td>
//                                     <td style={tdStyle}>{ad.adminId || "1"}</td>
//                                     <td style={tdStyle}>
//                                         <span style={{
//                                             padding: "4px 8px",
//                                             borderRadius: "4px",
//                                             backgroundColor: ad.paymentStatus === "PAID" ? "#4CAF50" : 
//                                                            ad.paymentStatus === "PENDING" ? "#FF9800" : "#f44336",
//                                             color: "white",
//                                             fontSize: "12px",
//                                             fontWeight: "500",
//                                             display: 'inline-block'
//                                         }}>
//                                             {ad.paymentStatus || "PENDING"}
//                                         </span>
//                                     </td>
//                                     <td style={tdStyle}>
//                                         <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
//                                             {ad.paymentStatus !== "PAID" && ad.vendorId > 0 && (
//                                                 <button
//                                                     style={{ 
//                                                         backgroundColor: "#4CAF50", 
//                                                         color: "white", 
//                                                         border: "none",
//                                                         padding: "6px 12px",
//                                                         borderRadius: "4px",
//                                                         cursor: "pointer",
//                                                         fontSize: "12px",
//                                                         fontWeight: "500",
//                                                         transition: 'background-color 0.2s',
//                                                         '&:hover': {
//                                                             backgroundColor: '#388e3c'
//                                                         }
//                                                     }}
//                                                     onClick={() => openPaymentModal(ad)}
//                                                 >
//                                                     Add Payment
//                                                 </button>
//                                             )}
//                                             <button
//                                                 style={{ 
//                                                     backgroundColor: "#f44336", 
//                                                     color: "white", 
//                                                     border: "none",
//                                                     padding: "6px 12px",
//                                                     borderRadius: "4px",
//                                                     cursor: "pointer",
//                                                     fontSize: "12px",
//                                                     fontWeight: "500",
//                                                     transition: 'background-color 0.2s',
//                                                     '&:hover': {
//                                                         backgroundColor: '#d32f2f'
//                                                     }
//                                                 }}
//                                                 onClick={() => handleDelete(ad.advertisementId)}
//                                             >
//                                                 Delete
//                                             </button>
//                                         </div>
//                                     </td>
//                                 </tr>
//                             ))
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Add Advertisement Modal */}
//             {(showAddModal || showPaymentModal) && (
//                 <div style={modalOverlayStyle} onClick={(e) => {
//                     if (e.target === e.currentTarget) {
//                         showAddModal ? setShowAddModal(false) : setShowPaymentModal(false);
//                     }
//                 }}>
//                     {showAddModal && (
//                         <div style={modalContentStyle} className="modal-enter">
//                             <div style={modalHeaderStyle}>
//                                 <h3 style={{ 
//                                     fontSize: isMobile ? '16px' : '18px', 
//                                     fontWeight: 'bold',
//                                     margin: 0,
//                                     color: '#333'
//                                 }}>
//                                     Add New Advertisement
//                                 </h3>
//                                 <button
//                                     style={{
//                                         background: 'transparent',
//                                         border: 'none',
//                                         fontSize: '20px',
//                                         cursor: 'pointer',
//                                         color: '#666',
//                                         fontWeight: 'bold',
//                                         padding: '0',
//                                         width: '30px',
//                                         height: '30px',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         borderRadius: '4px',
//                                         transition: 'background-color 0.2s',
//                                         '&:hover': {
//                                             backgroundColor: '#f0f0f0'
//                                         }
//                                     }}
//                                     onClick={() => setShowAddModal(false)}
//                                 >
//                                     ✕
//                                 </button>
//                             </div>

//                             <div style={modalBodyStyle}>
//                                 <form onSubmit={handleAddAdvertisement} style={{
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     gap: '15px'
//                                 }}>
//                                     <div>
//                                         <label style={labelStyle}>Title *</label>
//                                         <input
//                                             type="text"
//                                             name="title"
//                                             placeholder="Enter advertisement title"
//                                             value={formData.title}
//                                             onChange={handleChange}
//                                             required
//                                             style={inputStyle}
//                                         />
//                                     </div>

//                                     <div>
//                                         <label style={labelStyle}>Description</label>
//                                         <textarea
//                                             name="description"
//                                             placeholder="Enter advertisement description"
//                                             value={formData.description}
//                                             onChange={handleChange}
//                                             rows="3"
//                                             style={{ ...inputStyle, resize: 'vertical' }}
//                                         />
//                                     </div>

//                                     <div>
//                                         <label style={labelStyle}>Resolution *</label>
//                                         <div style={{ 
//                                             display: 'flex', 
//                                             gap: isMobile ? '10px' : '15px', 
//                                             marginTop: '5px',
//                                             flexWrap: 'wrap'
//                                         }}>
//                                             <label style={{ 
//                                                 display: 'flex', 
//                                                 alignItems: 'center', 
//                                                 gap: '5px',
//                                                 cursor: 'pointer'
//                                             }}>
//                                                 <input
//                                                     type="radio"
//                                                     name="resolution"
//                                                     value="HORIZONTAL"
//                                                     checked={formData.resolution === "HORIZONTAL"}
//                                                     onChange={handleChange}
//                                                     required
//                                                     style={{ cursor: 'pointer' }}
//                                                 />
//                                                 Horizontal
//                                             </label>
//                                             <label style={{ 
//                                                 display: 'flex', 
//                                                 alignItems: 'center', 
//                                                 gap: '5px',
//                                                 cursor: 'pointer'
//                                             }}>
//                                                 <input
//                                                     type="radio"
//                                                     name="resolution"
//                                                     value="VERTICAL"
//                                                     checked={formData.resolution === "VERTICAL"}
//                                                     onChange={handleChange}
//                                                     style={{ cursor: 'pointer' }}
//                                                 />
//                                                 Vertical
//                                             </label>
//                                         </div>
//                                     </div>

//                                     <div style={{ 
//                                         display: 'flex', 
//                                         gap: '15px',
//                                         flexDirection: isMobile ? 'column' : 'row'
//                                     }}>


//                                     </div>

//                                     <div style={{ 
//                                         display: 'flex', 
//                                         gap: '15px',
//                                         flexDirection: isMobile ? 'column' : 'row'
//                                     }}>
//                                         <div style={{ flex: 1 }}>
//                                             <label style={labelStyle}>Start Date *</label>
//                                             <input
//                                                 type="date"
//                                                 name="startDate"
//                                                 value={formData.startDate}
//                                                 min={new Date().toISOString().split('T')[0]}
//                                                 onChange={handleChange}
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                         </div>
//                                         <div style={{ flex: 1 }}>
//                                             <label style={labelStyle}>End Date *</label>
//                                             <input
//                                                 type="date"
//                                                 name="endDate"
//                                                 value={formData.endDate}
//                                                 onChange={handleChange}
//                                                 min={formData.startDate || new Date().toISOString().split('T')[0]}
//                                                 required
//                                                 style={inputStyle}
//                                             />
//                                         </div>
//                                     </div>

//                                     <div>
//                                         <label style={labelStyle}>Media File (Optional)</label>
//                                         <input
//                                             type="file"
//                                             accept="image/*,video/*"
//                                             onChange={handleFileChange}
//                                             style={{ 
//                                                 ...inputStyle, 
//                                                 padding: '8px',
//                                                 cursor: 'pointer'
//                                             }}
//                                         />
//                                         <small style={{ 
//                                             color: '#666', 
//                                             fontSize: '12px', 
//                                             marginTop: '5px', 
//                                             display: 'block' 
//                                         }}>
//                                             Supported: Images (JPG, PNG) and Videos (MP4)
//                                         </small>
//                                     </div>

//                                     <div style={{ 
//                                         display: 'flex', 
//                                         gap: '10px', 
//                                         marginTop: '20px'
//                                     }}>
//                                         <button
//                                             type="submit"
//                                             style={{
//                                                 padding: '12px',
//                                                 backgroundColor: '#1976d2',
//                                                 color: 'white',
//                                                 fontWeight: '600',
//                                                 border: 'none',
//                                                 borderRadius: '6px',
//                                                 cursor: 'pointer',
//                                                 flex: 1,
//                                                 fontSize: '14px',
//                                                 transition: 'background-color 0.3s',
//                                                 '&:hover': {
//                                                     backgroundColor: '#1565c0'
//                                                 }
//                                             }}
//                                         >
//                                             Add Advertisement
//                                         </button>
//                                         <button
//                                             type="button"
//                                             style={{
//                                                 padding: '12px',
//                                                 backgroundColor: '#f5f5f5',
//                                                 color: '#333',
//                                                 fontWeight: '600',
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '6px',
//                                                 cursor: 'pointer',
//                                                 flex: 1,
//                                                 fontSize: '14px',
//                                                 transition: 'all 0.3s',
//                                                 '&:hover': {
//                                                     backgroundColor: '#e0e0e0'
//                                                 }
//                                             }}
//                                             onClick={() => setShowAddModal(false)}
//                                         >
//                                             Cancel
//                                         </button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     )}

//                     {/* Add Payment Modal */}
//                     {showPaymentModal && selectedAd && (
//                         <div style={modalContentStyle} className="modal-enter">
//                             <div style={modalHeaderStyle}>
//                                 <h3 style={{ 
//                                     fontSize: isMobile ? '16px' : '18px', 
//                                     fontWeight: 'bold',
//                                     margin: 0,
//                                     color: '#333'
//                                 }}>
//                                     Mark as Paid
//                                 </h3>
//                                 <button
//                                     style={{
//                                         background: 'transparent',
//                                         border: 'none',
//                                         fontSize: '20px',
//                                         cursor: 'pointer',
//                                         color: '#666',
//                                         fontWeight: 'bold',
//                                         padding: '0',
//                                         width: '30px',
//                                         height: '30px',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         borderRadius: '4px',
//                                         transition: 'background-color 0.2s',
//                                         '&:hover': {
//                                             backgroundColor: '#f0f0f0'
//                                         }
//                                     }}
//                                     onClick={() => {
//                                         setShowPaymentModal(false);
//                                         setSelectedAd(null);
//                                         setPaymentAmount("");
//                                     }}
//                                 >
//                                     ✕
//                                 </button>
//                             </div>

//                             <div style={modalBodyStyle}>
//                                 <div style={{ 
//                                     display: 'flex', 
//                                     flexDirection: 'column', 
//                                     gap: '15px' 
//                                 }}>
//                                     <div>
//                                         <label style={labelStyle}>Advertisement ID</label>
//                                         <input
//                                             type="text"
//                                             value={selectedAd.advertisementId}
//                                             readOnly
//                                             style={{ 
//                                                 ...inputStyle, 
//                                                 backgroundColor: '#f5f5f5',
//                                                 cursor: 'not-allowed'
//                                             }}
//                                         />
//                                     </div>

//                                     <div>
//                                         <label style={labelStyle}>Title</label>
//                                         <input
//                                             type="text"
//                                             value={selectedAd.title || "-"}
//                                             readOnly
//                                             style={{ 
//                                                 ...inputStyle, 
//                                                 backgroundColor: '#f5f5f5',
//                                                 cursor: 'not-allowed'
//                                             }}
//                                         />
//                                     </div>

//                                     <div>
//                                         <label style={labelStyle}>Current Amount</label>
//                                         <input
//                                             type="text"
//                                             value={`₹${selectedAd.amount || "0"}`}
//                                             readOnly
//                                             style={{ 
//                                                 ...inputStyle, 
//                                                 backgroundColor: '#f5f5f5',
//                                                 cursor: 'not-allowed'
//                                             }}
//                                         />
//                                     </div>

//                                     <div>
//                                         <label style={labelStyle}>New Amount (₹) *</label>
//                                         <input
//                                             type="number"
//                                             value={paymentAmount}
//                                             onChange={(e) => setPaymentAmount(e.target.value)}
//                                             placeholder="Enter new amount"
//                                             style={inputStyle}
//                                             required
//                                             min="0"
//                                             step="0.01"
//                                         />
//                                     </div>

//                                     <div style={{ 
//                                         display: 'flex', 
//                                         gap: '10px', 
//                                         marginTop: '20px'
//                                     }}>
//                                         <button
//                                             style={{
//                                                 padding: '12px',
//                                                 backgroundColor: '#4CAF50',
//                                                 color: 'white',
//                                                 fontWeight: '600',
//                                                 border: 'none',
//                                                 borderRadius: '6px',
//                                                 cursor: 'pointer',
//                                                 flex: 1,
//                                                 fontSize: '14px',
//                                                 transition: 'background-color 0.3s',
//                                                 '&:hover': {
//                                                     backgroundColor: '#388e3c'
//                                                 }
//                                             }}
//                                             onClick={handleAddPayment}
//                                         >
//                                             Mark as Paid
//                                         </button>
//                                         <button
//                                             style={{
//                                                 padding: '12px',
//                                                 backgroundColor: '#f5f5f5',
//                                                 color: '#333',
//                                                 fontWeight: '600',
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '6px',
//                                                 cursor: 'pointer',
//                                                 flex: 1,
//                                                 fontSize: '14px',
//                                                 transition: 'all 0.3s',
//                                                 '&:hover': {
//                                                     backgroundColor: '#e0e0e0'
//                                                 }
//                                             }}
//                                             onClick={() => {
//                                                 setShowPaymentModal(false);
//                                                 setSelectedAd(null);
//                                                 setPaymentAmount("");
//                                             }}
//                                         >
//                                             Cancel
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// };

// // Reusable styles
// const inputStyle = {
//     padding: '10px',
//     border: '1px solid #ddd',
//     borderRadius: '6px',
//     width: '100%',
//     boxSizing: 'border-box',
//     fontSize: '14px',
//     transition: 'border-color 0.3s',
//     backgroundColor: '#fff',
// };

// const labelStyle = {
//     fontSize: '14px',
//     marginBottom: '6px',
//     display: 'block',
//     fontWeight: '500',
//     color: '#333'
// };

// // Add spinner animation
// const spinnerStyle = document.createElement('style');
// spinnerStyle.textContent = `
//     @keyframes spin {
//         0% { transform: rotate(0deg); }
//         100% { transform: rotate(360deg); }
//     }
// `;
// document.head.appendChild(spinnerStyle);

// export default FoodSuperadminAdvertisement;













import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider.jsx";

const FoodSuperadminAdvertisement = () => {
    const [advertisements, setAdvertisements] = useState([]);
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        resolution: "HORIZONTAL",
        startDate: "",
        endDate: "",
        mediaFile: null,
        vendorId: "",
        type: "IMAGE",
        adminId: 1
    });
    const [showAddModal, setShowAddModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [selectedAd, setSelectedAd] = useState(null);
    const [paymentAmount, setPaymentAmount] = useState("");
    const { showLoader, hideLoader } = useLoader();
    const [loading, setLoading] = useState(true);
    const isMobile = window.innerWidth <= 768;

    const tdStyle = {
        border: "1px solid #ccc",
        padding: "10px",
        textAlign: "left",
    };

    // Fetch valid advertisements
    useEffect(() => {
        const fetchAdvertisements = async () => {
            try {
                const token = localStorage.getItem("authToken");
                showLoader();
                setLoading(true);

                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/advertisements/valid`,
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );

                const adsArray = Array.isArray(response.data) ? response.data : [response.data];
                setAdvertisements(adsArray);

            } catch (error) {
                console.error("❌ Error fetching advertisements:", error);
                alert("Failed to fetch advertisements");
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        fetchAdvertisements();
    }, []);

    // Handle form input changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle file selection and set type
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        let type = "TEXT";
        if (file.type.startsWith("image/")) {
            type = "IMAGE";
        } else if (file.type.startsWith("video/")) {
            type = "VIDEO";
        }

        setFormData(prev => ({
            ...prev,
            mediaFile: file,
            type: type
        }));
    };

    // Add static advertisement
    const handleAddAdvertisement = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem("authToken");
            const adminId = localStorage.getItem("adminId") || 1;
            showLoader();

            if (!token) {
                alert("Session expired. Please login again.");
                return;
            }

            const advertisementData = {
                advertisementId: 0,
                title: formData.title || "Advertisement",
                type: formData.type || "IMAGE",
                description: formData.description || "",
                resolution: formData.resolution || "HORIZONTAL",
                startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
                endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
                vendorId: formData.vendorId ? parseInt(formData.vendorId) : 0,
                paymentStatus: "PAID",
                transactionId: "SUPERADMIN_STATIC",
                orderId: "SUPERADMIN_STATIC",
                adminId: parseInt(adminId),
                mediaUrl: ""
            };

            const fd = new FormData();
            fd.append(
                "advertisementData",
                new Blob([JSON.stringify(advertisementData)], { type: "application/json" })
            );

            if (formData.mediaFile) {
                fd.append("mediaFile", formData.mediaFile, formData.mediaFile.name);
            }

            console.log("Submitting advertisement:", advertisementData);

            const response = await axios.post(
                `https://backend.maamaas.com/food/api/advertisements/add-static-payment/1`,
                fd,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setAdvertisements(prev => [response.data, ...prev]);
            alert("Advertisement added successfully!");

            setFormData({
                title: "",
                description: "",
                resolution: "HORIZONTAL",
                startDate: "",
                endDate: "",
                mediaFile: null,
                vendorId: "",
                type: "IMAGE",
                adminId: 1
            });
            setShowAddModal(false);

        } catch (error) {
            console.error("❌ Error adding advertisement:", error.response?.data || error.message);
            alert(`Failed to add advertisement: ${error.response?.data?.message || error.message}`);
        } finally {
            hideLoader();
        }
    };

    // Handle payment (mark as paid)
    const handleAddPayment = async () => {
        if (!selectedAd || !paymentAmount) {
            alert("Please enter amount");
            return;
        }

        try {
            const token = localStorage.getItem("authToken");
            const adminId = localStorage.getItem("adminId") || 1;
            showLoader();

            const paymentData = {
                advertisementId: selectedAd.advertisementId,
                title: selectedAd.title || "Advertisement",
                type: selectedAd.type || "IMAGE",
                description: selectedAd.description || "",
                resolution: selectedAd.resolution || "HORIZONTAL",
                startDate: selectedAd.startDate ? new Date(selectedAd.startDate).toISOString() : null,
                endDate: selectedAd.endDate ? new Date(selectedAd.endDate).toISOString() : null,
                vendorId: selectedAd.vendorId || 0,
                paymentStatus: "PAID",
                transactionId: `SUPERADMIN_${Date.now()}`,
                orderId: `ORDER_${Date.now()}`,
                adminId: parseInt(adminId),
                mediaUrl: selectedAd.mediaUrl || ""
            };

            const fd = new FormData();
            fd.append(
                "advertisementData",
                new Blob([JSON.stringify(paymentData)], { type: "application/json" })
            );

            const response = await axios.post(
                `https://backend.maamaas.com/food/api/admin/advertisements/add-static-payment/1`,
                fd,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setAdvertisements(prev =>
                prev.map(ad =>
                    ad.advertisementId === selectedAd.advertisementId
                        ? response.data
                        : ad
                )
            );

            alert("Payment added successfully!");
            setShowPaymentModal(false);
            setSelectedAd(null);
            setPaymentAmount("");

        } catch (error) {
            console.error("❌ Error adding payment:", error.response?.data || error.message);
            alert(`Failed to add payment: ${error.response?.data?.message || error.message}`);
        } finally {
            hideLoader();
        }
    };

    // Delete advertisement
    const handleDelete = async (advertisementId) => {
        if (!window.confirm("Are you sure you want to delete this advertisement?")) {
            return;
        }

        try {
            const token = localStorage.getItem("authToken");
            showLoader();

            await axios.delete(
                `https://backend.maamaas.com/food/api/advertisements/delete/${advertisementId}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            setAdvertisements(prev => prev.filter(ad => ad.advertisementId !== advertisementId));
            alert("Advertisement deleted successfully!");

        } catch (error) {
            console.error("❌ Error deleting advertisement:", error.response?.data || error.message);
            alert(`Failed to delete advertisement: ${error.response?.data?.message || error.message}`);
        } finally {
            hideLoader();
        }
    };

    // Open payment modal
    const openPaymentModal = (advertisement) => {
        setSelectedAd(advertisement);
        setPaymentAmount("");
        setShowPaymentModal(true);
    };

    // Format date for display
    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    // Check if advertisement is admin-added (vendorId is 0)
    const isAdminAdded = (advertisement) => {
        return !advertisement.vendorId || advertisement.vendorId === 0;
    };

    // Get display status for advertisement
    const getDisplayStatus = (advertisement) => {
        if (isAdminAdded(advertisement)) {
            return "-";
        }
        return advertisement.paymentStatus || "PENDING";
    };

    // Get status background color
    const getStatusColor = (advertisement) => {
        if (isAdminAdded(advertisement)) {
            return "#9E9E9E"; // Grey for admin-added
        }
        return advertisement.paymentStatus === "PAID" ? "#4CAF50" :
            advertisement.paymentStatus === "PENDING" ? "#FF9800" : "#f44336";
    };

    // Modal styles
    const modalOverlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: isMobile ? '10px' : '20px',
        overflow: 'auto',
    };

    const modalContentStyle = {
        backgroundColor: '#fff',
        borderRadius: '8px',
        width: '100%',
        maxWidth: isMobile ? '95%' : '500px',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        animation: 'fadeIn 0.3s ease-out',
    };

    const modalHeaderStyle = {
        padding: isMobile ? '15px' : '20px',
        borderBottom: '1px solid #eee',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        backgroundColor: '#fff',
        zIndex: 1,
    };

    const modalBodyStyle = {
        padding: isMobile ? '15px' : '20px',
    };

    // Add CSS animation
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            @keyframes fadeIn {
                from {
                    opacity: 0;
                    transform: translateY(-20px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }
            
            @keyframes fadeOut {
                from {
                    opacity: 1;
                    transform: translateY(0);
                }
                to {
                    opacity: 0;
                    transform: translateY(-20px);
                }
            }
            
            .modal-enter {
                animation: fadeIn 0.3s ease-out;
            }
            
            .modal-exit {
                animation: fadeOut 0.3s ease-out;
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <div
            style={{
                maxWidth: '1200px',
                width: '100%',
                margin: '0 auto',
                padding: isMobile ? '15px' : '20px',
                position: 'relative',
            }}
        >
            {/* Header Section */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px',
                flexWrap: 'wrap',
                gap: '10px'
            }}>

                <button
                    style={{
                        padding: isMobile ? '8px 14px' : '10px 16px',
                        backgroundColor: '#1976d2',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: isMobile ? '13px' : '14px',
                        transition: 'background-color 0.3s',
                        '&:hover': {
                            backgroundColor: '#1565c0'
                        }
                    }}
                    onClick={() => setShowAddModal(true)}
                >
                    + Add Advertisement
                </button>
            </div>

            {/* Table Section */}
            <div style={{
                overflowX: 'auto',
                overflowY: 'auto',
                width: '100%',
                maxHeight: '60vh',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                border: '1px solid #e0e0e0',
            }}
            >
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        minWidth: '1000px',
                    }}
                >
                    <thead>
                        <tr>
                            {[
                                "S.No",
                                "Title",
                                "Description",
                                "Type",
                                "Resolution",
                                "Media",
                                "Start Date",
                                "End Date",
                                "Vendor ID",
                                "Admin ID",
                                "Status",
                                "Actions",
                            ].map((head, i) => (
                                <th
                                    key={i}
                                    style={{
                                        border: "1px solid #e0e0e0",
                                        padding: isMobile ? "8px" : "12px",
                                        backgroundColor: "#b15cd6",
                                        fontSize: isMobile ? "12px" : "14px",
                                        textAlign: "center",
                                        whiteSpace: "nowrap",
                                        color: "white",
                                        fontWeight: "600",
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 10,
                                    }}
                                >
                                    {head}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="12" style={{ textAlign: "center", padding: "40px" }}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        gap: '10px'
                                    }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '3px solid #f3f3f3',
                                            borderTop: '3px solid #b15cd6',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite'
                                        }}></div>
                                        <span style={{ color: '#666' }}>Loading advertisements...</span>
                                    </div>
                                </td>
                            </tr>
                        ) : advertisements.length === 0 ? (
                            <tr>
                                <td colSpan="12" style={{ textAlign: "center", padding: "40px" }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '15px',
                                        color: '#666'
                                    }}>
                                        <span>No advertisements found.</span>
                                        <button
                                            onClick={() => setShowAddModal(true)}
                                            style={{
                                                padding: '8px 16px',
                                                backgroundColor: '#1976d2',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontWeight: '500'
                                            }}
                                        >
                                            Create Your First Advertisement
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            advertisements.map((ad, index) => (
                                <tr key={ad.advertisementId} style={{
                                    backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
                                    transition: 'background-color 0.2s',
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0'
                                    }
                                }}>
                                    <td style={tdStyle}>{index + 1}</td>
                                    <td style={tdStyle}>{ad.title || "-"}</td>
                                    <td style={tdStyle}>{ad.description || "-"}</td>
                                    <td style={tdStyle}>
                                        <span style={{
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            backgroundColor: ad.type === "IMAGE" ? "#4CAF50" :
                                                ad.type === "VIDEO" ? "#2196F3" : "#9E9E9E",
                                            color: "white",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            display: 'inline-block'
                                        }}>
                                            {ad.type || "TEXT"}
                                        </span>
                                    </td>
                                    <td style={tdStyle}>
                                        {ad.resolution === "HORIZONTAL" ? "Horizontal" :
                                            ad.resolution === "VERTICAL" ? "Vertical" : "-"}
                                    </td>
                                    <td style={tdStyle}>
                                        {ad.mediaUrl ? (
                                            ad.type === "IMAGE" ? (
                                                <img
                                                    src={ad.mediaUrl}
                                                    alt="Advertisement"
                                                    style={{
                                                        width: "60px",
                                                        height: "60px",
                                                        objectFit: "cover",
                                                        borderRadius: "4px",
                                                        border: "1px solid #ccc",
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => window.open(ad.mediaUrl, '_blank')}
                                                />
                                            ) : ad.type === "VIDEO" ? (
                                                <div style={{ position: 'relative' }}>
                                                    <div
                                                        style={{
                                                            width: "60px",
                                                            height: "60px",
                                                            backgroundColor: '#2196F3',
                                                            borderRadius: "4px",
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            color: 'white',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => window.open(ad.mediaUrl, '_blank')}
                                                    >
                                                        ▶
                                                    </div>
                                                </div>
                                            ) : "Text Only"
                                        ) : "No Media"}
                                    </td>
                                    <td style={tdStyle}>{formatDate(ad.startDate)}</td>
                                    <td style={tdStyle}>{formatDate(ad.endDate)}</td>
                                    <td style={tdStyle}>{ad.vendorId || "0"}</td>
                                    <td style={tdStyle}>{ad.adminId || "1"}</td>
                                    <td style={tdStyle}>
                                        <span style={{
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            backgroundColor: getStatusColor(ad),
                                            color: "white",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            display: 'inline-block'
                                        }}>
                                            {getDisplayStatus(ad)}
                                        </span>
                                    </td>
                                    <td style={tdStyle}>
                                        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                                            {!isAdminAdded(ad) && ad.paymentStatus !== "PAID" && (
                                                <button
                                                    style={{
                                                        backgroundColor: "#4CAF50",
                                                        color: "white",
                                                        border: "none",
                                                        padding: "6px 12px",
                                                        borderRadius: "4px",
                                                        cursor: "pointer",
                                                        fontSize: "12px",
                                                        fontWeight: "500",
                                                        transition: 'background-color 0.2s',
                                                        '&:hover': {
                                                            backgroundColor: '#388e3c'
                                                        }
                                                    }}
                                                    onClick={() => openPaymentModal(ad)}
                                                >
                                                    Add Payment
                                                </button>
                                            )}
                                            <button
                                                style={{
                                                    backgroundColor: "#f44336",
                                                    color: "white",
                                                    border: "none",
                                                    padding: "6px 12px",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    transition: 'background-color 0.2s',
                                                    '&:hover': {
                                                        backgroundColor: '#d32f2f'
                                                    }
                                                }}
                                                onClick={() => handleDelete(ad.advertisementId)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Add Advertisement Modal */}
            {(showAddModal || showPaymentModal) && (
                <div style={modalOverlayStyle} onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        showAddModal ? setShowAddModal(false) : setShowPaymentModal(false);
                    }
                }}>
                    {showAddModal && (
                        <div style={modalContentStyle} className="modal-enter">
                            <div style={modalHeaderStyle}>
                                <h3 style={{
                                    fontSize: isMobile ? '16px' : '18px',
                                    fontWeight: 'bold',
                                    margin: 0,
                                    color: '#333'
                                }}>
                                    Add New Advertisement
                                </h3>
                                <button
                                    style={{
                                        background: 'transparent',
                                        border: 'none',
                                        fontSize: '20px',
                                        cursor: 'pointer',
                                        color: '#666',
                                        fontWeight: 'bold',
                                        padding: '0',
                                        width: '30px',
                                        height: '30px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '4px',
                                        transition: 'background-color 0.2s',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0'
                                        }
                                    }}
                                    onClick={() => setShowAddModal(false)}
                                >
                                    ✕
                                </button>
                            </div>

                            <div style={modalBodyStyle}>
                                <form onSubmit={handleAddAdvertisement} style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '15px'
                                }}>
                                    <div>
                                        <label style={labelStyle}>Title *</label>
                                        <input
                                            type="text"
                                            name="title"
                                            placeholder="Enter advertisement title"
                                            value={formData.title}
                                            onChange={handleChange}
                                            required
                                            style={inputStyle}
                                        />
                                    </div>

                                    <div>
                                        <label style={labelStyle}>Description</label>
                                        <textarea
                                            name="description"
                                            placeholder="Enter advertisement description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            rows="3"
                                            style={{ ...inputStyle, resize: 'vertical' }}
                                        />
                                    </div>

                                    <div>
                                        <label style={labelStyle}>Resolution *</label>
                                        <div style={{
                                            display: 'flex',
                                            gap: isMobile ? '10px' : '15px',
                                            marginTop: '5px',
                                            flexWrap: 'wrap'
                                        }}>
                                            <label style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                                cursor: 'pointer'
                                            }}>
                                                <input
                                                    type="radio"
                                                    name="resolution"
                                                    value="HORIZONTAL"
                                                    checked={formData.resolution === "HORIZONTAL"}
                                                    onChange={handleChange}
                                                    required
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                Horizontal
                                            </label>
                                            <label style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                                cursor: 'pointer'
                                            }}>
                                                <input
                                                    type="radio"
                                                    name="resolution"
                                                    value="VERTICAL"
                                                    checked={formData.resolution === "VERTICAL"}
                                                    onChange={handleChange}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                Vertical
                                            </label>
                                        </div>
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        gap: '15px',
                                        flexDirection: isMobile ? 'column' : 'row'
                                    }}>


                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        gap: '15px',
                                        flexDirection: isMobile ? 'column' : 'row'
                                    }}>
                                        <div style={{ flex: 1 }}>
                                            <label style={labelStyle}>Start Date *</label>
                                            <input
                                                type="date"
                                                name="startDate"
                                                value={formData.startDate}
                                                min={new Date().toISOString().split('T')[0]}
                                                onChange={handleChange}
                                                required
                                                style={inputStyle}
                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <label style={labelStyle}>End Date *</label>
                                            <input
                                                type="date"
                                                name="endDate"
                                                value={formData.endDate}
                                                onChange={handleChange}
                                                min={formData.startDate || new Date().toISOString().split('T')[0]}
                                                required
                                                style={inputStyle}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label style={labelStyle}>Media File (Optional)</label>
                                        <input
                                            type="file"
                                            accept="image/*,video/*"
                                            onChange={handleFileChange}
                                            style={{
                                                ...inputStyle,
                                                padding: '8px',
                                                cursor: 'pointer'
                                            }}
                                        />
                                        <small style={{
                                            color: '#666',
                                            fontSize: '12px',
                                            marginTop: '5px',
                                            display: 'block'
                                        }}>
                                            Supported: Images (JPG, PNG) and Videos (MP4)
                                        </small>
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        gap: '10px',
                                        marginTop: '20px'
                                    }}>
                                        <button
                                            type="submit"
                                            style={{
                                                padding: '12px',
                                                backgroundColor: '#1976d2',
                                                color: 'white',
                                                fontWeight: '600',
                                                border: 'none',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                flex: 1,
                                                fontSize: '14px',
                                                transition: 'background-color 0.3s',
                                                '&:hover': {
                                                    backgroundColor: '#1565c0'
                                                }
                                            }}
                                        >
                                            Add Advertisement
                                        </button>
                                        <button
                                            type="button"
                                            style={{
                                                padding: '12px',
                                                backgroundColor: '#f5f5f5',
                                                color: '#333',
                                                fontWeight: '600',
                                                border: '1px solid #ddd',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                flex: 1,
                                                fontSize: '14px',
                                                transition: 'all 0.3s',
                                                '&:hover': {
                                                    backgroundColor: '#e0e0e0'
                                                }
                                            }}
                                            onClick={() => setShowAddModal(false)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {/* Add Payment Modal */}
                    {showPaymentModal && selectedAd && (
                        <div style={modalContentStyle} className="modal-enter">
                            <div style={modalHeaderStyle}>
                                <h3 style={{
                                    fontSize: isMobile ? '16px' : '18px',
                                    fontWeight: 'bold',
                                    margin: 0,
                                    color: '#333'
                                }}>
                                    Mark as Paid
                                </h3>
                                <button
                                    style={{
                                        background: 'transparent',
                                        border: 'none',
                                        fontSize: '20px',
                                        cursor: 'pointer',
                                        color: '#666',
                                        fontWeight: 'bold',
                                        padding: '0',
                                        width: '30px',
                                        height: '30px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '4px',
                                        transition: 'background-color 0.2s',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0'
                                        }
                                    }}
                                    onClick={() => {
                                        setShowPaymentModal(false);
                                        setSelectedAd(null);
                                        setPaymentAmount("");
                                    }}
                                >
                                    ✕
                                </button>
                            </div>

                            <div style={modalBodyStyle}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '15px'
                                }}>
                                    <div>
                                        <label style={labelStyle}>Advertisement ID</label>
                                        <input
                                            type="text"
                                            value={selectedAd.advertisementId}
                                            readOnly
                                            style={{
                                                ...inputStyle,
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'not-allowed'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={labelStyle}>Title</label>
                                        <input
                                            type="text"
                                            value={selectedAd.title || "-"}
                                            readOnly
                                            style={{
                                                ...inputStyle,
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'not-allowed'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={labelStyle}>Amount (₹) *</label>
                                        <input
                                            type="number"
                                            value={paymentAmount}
                                            onChange={(e) => setPaymentAmount(e.target.value)}
                                            placeholder="Enter amount"
                                            style={inputStyle}
                                            required
                                            min="0"
                                            step="0.01"
                                        />
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        gap: '10px',
                                        marginTop: '20px'
                                    }}>
                                        <button
                                            style={{
                                                padding: '12px',
                                                backgroundColor: '#4CAF50',
                                                color: 'white',
                                                fontWeight: '600',
                                                border: 'none',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                flex: 1,
                                                fontSize: '14px',
                                                transition: 'background-color 0.3s',
                                                '&:hover': {
                                                    backgroundColor: '#388e3c'
                                                }
                                            }}
                                            onClick={handleAddPayment}
                                        >
                                            Mark as Paid
                                        </button>
                                        <button
                                            style={{
                                                padding: '12px',
                                                backgroundColor: '#f5f5f5',
                                                color: '#333',
                                                fontWeight: '600',
                                                border: '1px solid #ddd',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                flex: 1,
                                                fontSize: '14px',
                                                transition: 'all 0.3s',
                                                '&:hover': {
                                                    backgroundColor: '#e0e0e0'
                                                }
                                            }}
                                            onClick={() => {
                                                setShowPaymentModal(false);
                                                setSelectedAd(null);
                                                setPaymentAmount("");
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// Reusable styles
const inputStyle = {
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    width: '100%',
    boxSizing: 'border-box',
    fontSize: '14px',
    transition: 'border-color 0.3s',
    backgroundColor: '#fff',
};

const labelStyle = {
    fontSize: '14px',
    marginBottom: '6px',
    display: 'block',
    fontWeight: '500',
    color: '#333'
};

// Add spinner animation
const spinnerStyle = document.createElement('style');
spinnerStyle.textContent = `
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
document.head.appendChild(spinnerStyle);

export default FoodSuperadminAdvertisement;